module["exports"] = [
  "Abrantes",
  "Agualva-Cacém",
  "Águeda",
  "Albufeira",
  "Alcácer do Sal",
  "Alcobaça",
  "Alfena",
  "Almada",
  "Almeirim",
  "Amadora",
  "Amarante",
  "Amora",
  "Anadia",
  "Angra do Heroísmo",
  "Aveiro",
  "Barcelos",
  "Barreiro",
  "Beja",
  "Braga",
  "Bragança",
  "Caldas da Rainha",
  "Câmara de Lobos",
  "Caniço",
  "Cantanhede",
  "Cartaxo",
  "Castelo Branco",
  "Chaves",
  "Coimbra",
  "Costa da Caparica",
  "Covilhã",
  "Elvas",
  "Entroncamento",
  "Ermesinde",
  "Esmoriz",
  "Espinho",
  "Esposende",
  "Estarreja",
  "Estremoz",
  "Évora",
  "Fafe",
  "Faro",
  "Fátima",
  "Felgueiras",
  "Fiães",
  "Figueira da Foz",
  "Freamunde",
  "Funchal",
  "Fundão",
  "Gafanha da Nazaré",
  "Gandra",
  "Gondomar",
  "Gouveia",
  "Guarda",
  "Guimarães",
  "Horta",
  "Ílhavo",
  "Lagoa",
  "Lagos",
  "Lamego",
  "Leiria",
  "Lisbon",
  "Lixa",
  "Loulé",
  "Loures",
  "Lourosa",
  "Macedo de Cavaleiros",
  "Machico",
  "Maia",
  "Mangualde",
  "Marco de Canaveses",
  "Marinha Grande",
  "Matosinhos",
  "Mealhada",
  "Mêda",
  "Miranda do Douro",
  "Mirandela",
  "Montemor-o-Novo",
  "Montijo",
  "Moura",
  "Odivelas",
  "Olhão da Restauração",
  "Oliveira de Azeméis",
  "Oliveira do Bairro",
  "Oliveira do Hospital",
  "Ourém",
  "Ovar",
  "Paços de Ferreira",
  "Paredes",
  "Penafiel",
  "Peniche",
  "Peso da Régua",
  "Pinhel",
  "Pombal",
  "Ponta Delgada",
  "Ponte de Sor",
  "Portalegre",
  "Portimão",
  "Porto",
  "Póvoa de Santa Iria",
  "Póvoa de Varzim",
  "Praia da Vitória",
  "Quarteira",
  "Queluz",
  "Rebordosa",
  "Reguengos de Monsaraz",
  "Ribeira Grande",
  "Rio Maior",
  "Rio Tinto",
  "Sabugal",
  "Sacavém",
  "Santa Comba Dão",
  "Santa Cruz",
  "Santa Maria da Feira",
  "Santana",
  "Santarém",
  "Santiago do Cacém",
  "Santo Tirso",
  "São João da Madeira",
  "São Mamede de Infesta",
  "São Salvador de Lordelo",
  "Seia",
  "Seixal",
  "Serpa",
  "Setúbal",
  "Silves",
  "Sines",
  "Tarouca",
  "Tavira",
  "Tomar",
  "Tondela",
  "Torres Novas",
  "Torres Vedras",
  "Trancoso",
  "Trofa",
  "Valbom",
  "Vale de Cambra",
  "Valongo",
  "Valpaços",
  "Vendas Novas",
  "Viana do Castelo",
  "Vila Baleira (a.k.a. Porto Santo)",
  "Vila do Conde",
  "Vila Franca de Xira",
  "Vila Nova de Famalicão",
  "Vila Nova de Foz Côa",
  "Vila Nova de Gaia",
  "Vila Nova de Santo André",
  "Vila Real",
  "Vila Real de Santo António",
  "Viseu",
  "Vizela"
];
